import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeBomWire } from '#/api/momMgmt/settings/bom/normalizeBomWire';

export async function activateBom(id, payload = {}) {
  const { data: raw } = await request.post(
    `/mom/bom/${id}/activate`,
    keysToSnake(payload),
  );
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeBomWire(parsed.data),
  };
}
